<template>
	<el-button
		@click.prevent="toggle()"
		:class="toggleClass"
		:size="size"
		:type="type"
		>
		<i class="toggle-icon" v-if="toggleIcon" :class="iconClass"></i>
		<span v-if="toggleText"
			:class="{
				'toggle-text-only' : !toggleIcon,
				'toggle-text hidden sm:inline-block' : type === 'text'
			}">{{ toggleText }}</span>
	</el-button>
</template>

<script>
	export default{
		props : {
			user: {
				type: Object
			},
			toggled: {
				type: [Boolean, Number],
				default: false
			},
			onClass: {
				type: String,
				default: 'is-active',
			},
			offClass: {
				type: String,
				default: '',
			},
			onText: {
				type: String,
				default: 'On'
			},
			offText: {
				type: String,
				default: 'Off'
			},
			onIcon: {
				type: String,
				default: ''
			},
			offIcon: {
				type: String,
				default: ''
			},
			size: {
				type: String
			},
			type: {
				type: String
			}
		},

		data() {
			return {
				isOn: this.toggled
			}
		},

		computed : {
			toggleClass() {
				return this.isOn ? this.onClass : this.offClass;
			},
			iconClass() {
				return 'tbb-icon-' + this.toggleIcon;
			},
			toggleText() {
				return this.isOn ? this.onText : this.offText;
			},
			toggleIcon() {
				let offIcon = this.offIcon === '' ? this.onIcon : this.offIcon;

				return this.isOn ? this.onIcon : offIcon;
			},
			toggleAction() {
				return this.isOn ? 'activated' : 'deactivated';
			}
		},

		watch: {
			toggled() {
				this.isOn = this.toggled;
			}
		},

		methods : {
			toggle() {
				this.isOn = !this.isOn;

				// emit state-specific event
				this.$emit(this.toggleAction);

				// emit toggle event
				this.$emit('toggled', this.isOn);
			}
		}
	}
</script>
